
import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import ZeegBookingButton from '@/components/booking/ZeegBookingButton';

const BusinessPricingHeader: React.FC = () => {
  return (
    <div className="text-center max-w-3xl mx-auto mb-12">
      <span className="inline-block text-primary font-medium mb-4 px-3 py-1 bg-primary/10 rounded-full text-sm">
        Angebote für Unternehmen
      </span>
      <h2 className="mb-4">
        Katalysator-Führung & Executive Coaching
      </h2>
      <p className="text-joerg-600">
        Maßgeschneiderte Begleitung für Führungskräfte und Teams.
      </p>
      
      {/* Note about MwSt moved here for better visibility */}
      <p className="mt-2 text-sm text-joerg-500 bg-joerg-50 inline-block px-3 py-1 rounded-full">
        Alle Preise verstehen sich zzgl. 19% MwSt.
      </p>
      
      {/* Direct CTA */}
      <div className="mt-8 flex flex-col sm:flex-row justify-center gap-4">
        <Link
          to="/kontakt?type=business"
          className="inline-flex items-center justify-center px-6 py-3 rounded-full bg-primary text-white hover:bg-primary-dark transition-colors shadow-md hover:shadow-lg"
        >
          Unverbindliches Angebot anfragen <ArrowRight className="ml-2 h-4 w-4" />
        </Link>
        <ZeegBookingButton 
          className="bg-white border border-joerg-200 text-joerg-800 hover:bg-joerg-50"
          text="Erstgespräch vereinbaren"
        />
      </div>
    </div>
  );
};

export default BusinessPricingHeader;
